/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Update_EntityInputs */

const cs_automation_update_entity = /** @type {(inputs: Automation_Update_EntityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entita`)
};

const en_automation_update_entity = /** @type {(inputs: Automation_Update_EntityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entity`)
};

/**
* | output |
* | --- |
* | "Entity" |
*
* @param {Automation_Update_EntityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_update_entity = /** @type {((inputs?: Automation_Update_EntityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Update_EntityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_update_entity(inputs)
	return cs_automation_update_entity(inputs)
});